/*=============================
=         Form Process        =
=============================*/

var formMessage = document.getElementById('form-message');

[].slice.call(document.querySelectorAll('.ajax-form')).forEach(function(form) {
	form.addEventListener('submit', formProcess);
});

const conditionalDisplay = {
    is_corp: {
        '1': ['corp_input'],
        '0': ['corp_input'],
    },
    is_honor: {
        '1': ['honor_input'],
        '0': ['honor_input'],
    }
}

for (const key in conditionalDisplay) {
    for (const val in conditionalDisplay[key]) {
        const field = document.getElementById(key)
        if (field) {
            field.addEventListener('change', () => handleConditionalDisplay(field, val, conditionalDisplay[key][val]))
        }
    }
}

function hideFormContent() {
    const formContent = document.querySelector('.form-content')
    if (formContent) {
        Velocity(formContent, 'slideUp', { duration: 200 })
    }
}

function handleConditionalDisplay(controller, value, fieldNames) {
    for (let i=0; i<fieldNames.length; i++) {
        const controlledField = document.getElementById(fieldNames[i])
        if (controlledField) {
            const wrapper = controlledField.closest('.hidden')
            const style = window.getComputedStyle(wrapper)
            if (controller.value === value) {
                if (style.display === 'none') {
                    Velocity(wrapper, 'slideDown', { duration: 200 })
                    controlledField.setAttribute('required', '')
                    document.querySelector(`label[for='${fieldNames}']`).innerHTML +='<span class=\'required-field\'>*</span>'
                }
            } else {
                if (style.display === 'block') {
                    Velocity(wrapper, 'slideUp', { duration: 200 })
                    controlledField.removeAttribute('required')
                    let parent = document.querySelector(`label[for='${fieldNames}']`)
                    parent.removeChild(parent.children[0])
                }
            }
        }
    }
}

function setFormMessage(message, success) {
    if (success) {
        formMessage.classList.add('success');
        formMessage.classList.remove('error');
    } else {
        formMessage.classList.add('error');
        formMessage.classList.remove('success');
    }
    formMessage.innerHTML = message;

}

function formProcess(e) {
	if('performance' in window === false)
		return true;

	e.preventDefault();

	var form = this,
		data = new FormData(form),
		button = this.querySelector('button[type="submit"]');

	button.classList.add('disabled');

	data.append('c_time', performance.now() >= 7000 ? 0 : 1);

	axios.post(form.action, data)
		.then(function(r) {
			form.classList.add('hidden');
			clearErrors(form);
            setFormMessage(r.data.message.value, true)

			dataLayerPush(r.data.title.value, true);

            if (r.data.lightbox) {
                hideFormContent()
                loadLightbox(r.data.update_url, r.data.lightbox, r.data.uuid)
            }
		})
		.catch(function (e) {
            console.log(e)
			setTimeout(function() {
				button.classList.remove('disabled');
			}, 500);

            setFormMessage(e.response.data.message.value, false)

			if(e.response.status===422) {
				clearErrors(form);
				setErrors(form, e.response.data);
			}

			dataLayerPush(e.response.data.title.value, false);
		});
}

function loadLightbox(update_url, token, uuid) {
    const paymentFields = {
        ssl_txn_auth_token: token
    }

    const callback = {
        onError: function(error) {
            console.log('error')
            console.log(error)
        },
        onCancelled: function() {
            console.log('cancelled')
            console.log(response)
        },
        onDeclined: function(response) {
            console.log('payment declined')
            console.log(response)
        },
        onApproval: function(response) {
            axios.post(update_url, {
                registration: uuid,
                paid: response.ssl_amount
            }).then(function (r) {
                setFormMessage(r.data.message.value, true)
            }).catch(function (r) {
                setFormMessage(r.data.message.value, false)
            })
        }
    }

    window.PayWithConverge.open(paymentFields, callback)

    return false
}

function clearErrors(form) {
	var errors = form.getElementsByClassName('error');

	for(var e=errors.length - 1; e>=0; e--)
		errors[e].classList.remove('error');

	Velocity(formMessage, 'scroll', {
		duration: 500,
		offset: -1 * (header.offsetHeight + 50)
	});
}

function setErrors(form, responseData) {
	var errors = responseData.errors,
		style = window.getComputedStyle(formMessage);

	if(style.display !== 'none') {
		formMessage.classList.add('error');
		formMessage.innerHTML = responseData.message.value;
	}

	for(var key in errors) {
		var label = form.querySelector('label[for="'+key+'"]');

		if(label)
			label.parentNode.classList.add('error');

		if(key == 'g-recaptcha-response')
			document.querySelector('.g-recaptcha').classList.add('error');
	}
}

function dataLayerPush(title, success) {
	var data = {
		'event': 'FormSubmission',
		'formTitle': title,
		'formSuccess': success
	};

	if(typeof dataLayer !== 'undefined')
		dataLayer.push(data);
}
